module.exports = __webpack_public_path__ + "img/11_14.c907225b.png";